<template>
  <div class="table-wrapper">
    <div class="table-header">
      <div class="export-actions">
        <IconButton 
          @handle:click="exportPDF" 
          title="Exportar como PDF"
          color="primary"
          :disabled="loading"
        >
          <FileOutline :size="18" />
        </IconButton>
        <IconButton 
          @handle:click="exportXLSX" 
          title="Exportar como Excel"
          color="success"
          :disabled="loading"
        >
          <FileExcelOutline :size="18" />
        </IconButton>
        <IconButton 
          @handle:click="exportTXT" 
          title="Exportar como TXT"
          color="secondary"
          :disabled="loading"
        >
          <FileDocumentOutline :size="18" />
        </IconButton>
      </div>
      
      <!-- <div class="search-container">
        <Input
          :modelValue="search"
          @update:modelValue="handleSearchChange"
          legend="Pesquisar"
          placeholder="Busque por matéria ou instrutor..."
          :disabled="loading"
        />
      </div> -->
    </div>

    <div v-if="loading" class="loading-container">
      <LoadingSpinner :size="60" />
    </div>

    <div v-else class="table-responsive">
      <Table :headers="tableHeaders">
        <tr v-for="aula in aulas" :key="aula.id">
          <td>{{ aula.nome }}</td>
          <td>{{ aula.titulo }}</td>
          <td>{{ utils.formatDate(aula.inicio) }}</td>
          <td>{{ utils.formatDate(aula.fim) }}</td>
          <td>{{ aula.duracao_minutos }}</td>
          <td>{{ aula.quantidade_alunos_presentes || 0 }}</td>
        </tr>
        
        <tr v-if="aulas.length === 0">
          <td :colspan="tableHeaders.length" class="text-center">
            Nenhum registro encontrado.
          </td>
        </tr>
      </Table>

      <div class="pagination-container" v-if="aulas.length > 0">
        <Paginate
          :total-pages="paginationData.lastPage"
          :current-page="paginationData.currentPage"
          @page-changed="fetchAulas"
        />
      </div>
    </div>
  </div>
</template>

<script>
import * as spinners from 'epic-spinners'
import urlApi from '../../../router/urlApi'
import utils from '../../../services/utils'
import Table from 'core/Table'
import Input from 'core/Input'
import Paginate from 'core/Paginate'
import IconButton from 'core/IconButton'
import LoadingSpinner from 'core/LoadingSpinner'
import FileOutline from 'icons/FileOutline'
import FileExcelOutline from 'icons/FileExcelOutline'
import FileDocumentOutline from 'icons/FileDocumentOutline'
import { debounce } from 'lodash'

export default {
  name: 'TableAulas',
  components: {
    ...spinners,
    Table,
    Input,
    Paginate,
    IconButton,
    LoadingSpinner,
    FileOutline,
    FileExcelOutline,
    FileDocumentOutline
  },
  props: {
    idTurma: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      search: '',
      aulas: [],
      loading: false,
      tableHeaders: ['Instrutor', 'Matéria', 'Início', 'Final', 'Duração', 'Alunos Presentes'],
      paginationData: {
        currentPage: 1,
        lastPage: 1,
        total: 0
      },
      utils
    }
  },
  mounted() {
    this.fetchAulas(1)
  },
  methods: {
    async fetchAulas(page = 1) {
      this.loading = true
      try {
        const response = await this.$http.get(`${urlApi}/aulas/teoricas/paginacao/${this.idTurma}`, {
          params: {
            page,
            search: this.search
          }
        })
        
        const responseData = response.data
        this.aulas = responseData.data
        
        this.paginationData = {
          currentPage: responseData.current_page,
          lastPage: responseData.last_page,
          total: responseData.total
        }
      } catch (error) {
        this.toast('Erro ao carregar aulas')
        console.error('Erro ao buscar aulas:', error)
      } finally {
        this.loading = false
      }
    },
    exportPDF() {
      try {
        this.utils.generatePDFTurmas(
          this.idTurma,
          '/aulas/teoricas',
          'pdf',
          'aulas teoricas'
        )
        this.toast('Exportação PDF iniciada com sucesso!', 'success')
      } catch (error) {
        this.toast('Erro ao exportar PDF')
      }
    },
    exportXLSX() {
      try {
        this.utils.generatePDFTurmas(
          this.idTurma,
          'aulas/teoricas',
          'xlsx',
          'aulas teoricas'
        )
        this.toast('Exportação Excel iniciada com sucesso!', 'success')
      } catch (error) {
        this.toast('Erro ao exportar Excel')
      }
    },
    exportTXT() {
      try {
        this.utils.generatePDFTurmas(
          this.idTurma,
          'aulas/teoricas',
          'txt',
          'aulas teoricas'
        )
        this.toast('Exportação TXT iniciada com sucesso!', 'success')
      } catch (error) {
        this.toast('Erro ao exportar TXT')
      }
    },
    handleSearchChange: debounce(function(value) {
      this.search = value
      this.fetchAulas(1)
    }, 500),
    toast(message, type = 'error') {
      const icon = type === 'success' ? 'fa-check-circle' : 'fa-times'
      this.$toasted.show(message, {
        icon: icon,
        position: 'top-right',
        duration: 3000
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.table-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
  
  .export-actions {
    display: flex;
    gap: 0.5rem;
  }
  
  .search-container {
    width: 300px;
  }
}

.loading-container {
  display: flex;
  justify-content: center;
  padding: 2rem 0;
}

.pagination-container {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
}

.text-center {
  text-align: center;
}

@media (max-width: 768px) {
  .table-header {
    flex-direction: column;
    align-items: flex-start;
    
    .search-container {
      width: 100%;
    }
  }
}
</style>
